import { useContext, useEffect, useState } from 'react'
import PrefersReducedMotionContext from 'contexts/PrefersReducedMotionContext'

const PLACEHOLDER_ROTATE_MS = 2500
export const PLACEHOLDER_SLIDE_MS = 350

interface RotatingPlaceholder {
  item: string
  nextItem: string
  isRotating: boolean
}

/** Cycles through `items`, sliding each out as the next comes in; holds the current item while paused. */
export function useRotatingPlaceholder(items: readonly [string, ...Array<string>], isPaused: boolean): RotatingPlaceholder {
  const prefersReducedMotion = useContext(PrefersReducedMotionContext)
  const [index, setIndex] = useState(0)
  const [isRotating, setIsRotating] = useState(false)
  const itemCount = items.length

  useEffect(() => {
    if (isPaused || itemCount < 2) return

    if (isRotating) {
      const timeout = setTimeout(() => {
        setIndex(current => (current + 1) % itemCount)
        setIsRotating(false)
      }, PLACEHOLDER_SLIDE_MS)
      return () => clearTimeout(timeout)
    }

    const timeout = setTimeout(() => {
      if (prefersReducedMotion) {
        setIndex(current => (current + 1) % itemCount)
      } else {
        setIsRotating(true)
      }
    }, PLACEHOLDER_ROTATE_MS)
    return () => clearTimeout(timeout)
  }, [index, isRotating, isPaused, itemCount, prefersReducedMotion])

  return {
    item: items[index],
    nextItem: items[(index + 1) % itemCount],
    isRotating: isRotating && !isPaused,
  }
}
